const validateCommunityDetails = (value, fieldName) => {
  //console.logvalue, fieldName, "oi");
  switch (fieldName) {
    case "categoryId":
      return !value ? "Category is required" : "";
    case "city":
      return !value ? "City is required" : "";
    case "state":
      return !value ? "State is required" : "";
    case "description":
      return !value ? "Description is required" : "";
    case "images":
      return !value ? "Please upload atleast one file" : "";
    default:
      return "";
  }
};

export { validateCommunityDetails };
